import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Chat from './pages/Chat';
import GPTs from './pages/Gpts';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LoadingSpinner from './components/LoadingSpinner';

const AppRoutes: React.FC = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const waitForImages = () => {
      const images = Array.from(document.images);
      const unloaded = images.filter(img => !img.complete);

      const revealPage = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        setLoading(false);
      };

      if (unloaded.length === 0) {
        setTimeout(revealPage, 300);
        return;
      }

      let count = 0;
      unloaded.forEach(img => {
        img.onload = img.onerror = () => {
          count++;
          if (count === unloaded.length) {
            setTimeout(revealPage, 300);
          }
        };
      });
    };

    const timeout = setTimeout(waitForImages, 100);
    return () => clearTimeout(timeout);
  }, [location]);

  if (loading) return <LoadingSpinner />;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/GPTs" element={<GPTs />} />
    </Routes>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Navbar />
        <main>
          <AppRoutes />
        </main>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
